import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class KnowledgeShareBaseApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'knowledgeshare-base'
  }

    /**
   * OSS上传富文本
   * @param param 
   * @returns 
   */
    public saveData(param) {
      return this.send(param, "saveData", this.Methods.POST)
  }
  
  
    /**
   * 富文本
   * @param param 
   * @returns 
   */
    public getKnowledgeshareBase(param) {
      return this.send(param, "getKnowledgeshareBase", this.Methods.GET)
  }
  

}